import React from "react";
import { ApolloProvider } from "@apollo/react-hooks";
import App from "apps/messenger/containers/App";
import getApolloClient from "shared/util/getApolloClient";

const Messenger = () => (
	<ApolloProvider client={getApolloClient()}>
		<App />
	</ApolloProvider>
);

export default Messenger;



// WEBPACK FOOTER //
// ./src/apps/messenger/index.js